'use client';

import React, { useState } from 'react';
import { VStack } from '@skin-seoul/design-system';
import ModalContainer from '../../../components/ModalContainer';
import StarIngredientItem from './StarIngredientItem';
import type { StarIngredient } from '@skin-seoul/service';
interface StarIngredientsModalProps {
  isOpen: boolean;
  onClose: () => void;
  starIngredients: StarIngredient[];
}
const StarIngredientsModal = ({
  isOpen,
  onClose,
  starIngredients
}: StarIngredientsModalProps) => {
  const [expandedItem, setExpandedItem] = useState<number | null>(0);
  const handleToggle = (index: number) => {
    setExpandedItem(expandedItem === index ? null : index);
  };
  return <ModalContainer isOpen={isOpen} onClose={onClose} title="Star Ingredients" data-sentry-element="ModalContainer" data-sentry-component="StarIngredientsModal" data-sentry-source-file="StarIngredientsModal.tsx">
      <VStack gap={2} width="100%" alignItems="stretch" data-sentry-element="VStack" data-sentry-source-file="StarIngredientsModal.tsx">
        {starIngredients.map((ingredient, index) => <StarIngredientItem key={index} name={ingredient.engName} efficacy={ingredient.efficacy} efficacyDescription={ingredient.efficacyDescription} isExpanded={expandedItem === index} onToggle={() => handleToggle(index)} isInModal={true} />)}
      </VStack>
    </ModalContainer>;
};
export default StarIngredientsModal;